import { toast } from "react-toastify";
import baseApi from "../../../API/baseApi";
import routes from "../../../API/routes";

export async function listarRestituicao(filtros) {
    try {
        const response = await baseApi.get(`${routes.restituicao.listarResultados}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar as informações de restituição.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar as informações de restituição.');
        return null;
    }
}

export async function exportarRelatorio(cpf) {
    try {
        const response = await baseApi.get(`${routes.restituicao.exportarRelatorio}`, { cpf: cpf }, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `relatorio-restituicao-${cpf}.xlsx`);
            document.body.appendChild(link);
            link.click();

            toast.success('Relatório gerado com sucesso.');
            return { sucesso: true };
        }else {
            toast.error(response.data.message || 'Erro ao gerar relatório.');
            return { sucesso: false, mensagem: response.data.message || 'Erro ao gerar relatório.' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Erro ao gerar relatório.');
        return { sucesso: false, mensagem: errorMessage || 'Erro ao gerar relatório.' };
    }
}

export async function buscarEspelho(filtros) {
    try {
        const response = await baseApi.get(`${routes.restituicao.buscarEspelho}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao buscar o espelho do PER/DCOMP.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao buscar o espelho do PER/DCOMP.');
        return null;
    }
}

export async function buscarTodosEspelhos(filtros) {
    try {
        const response = await baseApi.get(`${routes.restituicao.buscarTodosEspelhos}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao gerar o relatório.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao gerar o relatório.');
        return null;
    }
}
